@if (parentFormGroup.controls[startDateControlName] && parentFormGroup.controls[endDateControlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label
        [class.error]="error"
        class="label"
        >
        {{ label }}
        @if (isRequired) {
          <span>*&nbsp;</span>
          }:
        </mat-label>
      }
      <mat-date-range-input [rangePicker]="picker" [min]="min" [max]="max">
        <input
          [formControlName]="startDateControlName"
          [disabled]="isDisabled"
          [required]="isRequired"
          [readonly]="true"
          (click)="openPicker()"
          (focus)="openPicker()"
          (keydown)="$event.preventDefault()"
          (paste)="$event.preventDefault()"
          matStartDate
          placeholder="{{placeholderStart}}"
          class="input date-input"
          />
        <input
          [formControlName]="endDateControlName"
          [disabled]="isDisabled"
          [required]="isRequired"
          [readonly]="true"
          (click)="openPicker()"
          (focus)="openPicker()"
          (keydown)="$event.preventDefault()"
          (paste)="$event.preventDefault()"
          matEndDate
          placeholder="{{placeholderEnd}}"
          class="input date-input"
          />
      </mat-date-range-input>
      @if (parentFormGroup.controls[startDateControlName].status !== 'DISABLED') {
        <mat-icon
          class="suffix-icon"
          matSuffix
          svgIcon="calender-light"
          (click)="picker.open()"
          style="cursor: pointer"
          />
      }
      <mat-date-range-picker #picker [calendarHeaderComponent]="calendarHeader" (opened)="onPickerOpened()"></mat-date-range-picker>
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-form-field>
  }
